import React, { useEffect, useRef, useState } from "react";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import { CgColorPicker } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { Box, Flex } from "rebass";
import { yodaOrdersActions } from "../../logic/actions";
import { getLocalizedString } from "../../utils";
import config from "../../utils/globalConfig";
import { Price } from "../common/Price";
import { ProductImage } from "../common/ProductImage";
import ColorsSideBar from "./ColorsSideBar";
import OrderInfo from "./OrderInfo";
import { ToastMessage } from "./ToastMessage";
import OrderInfoRow from "./OrderInfoRow";

const MobileOrderDetailSwap = ({
  id,
  modelCode,
  previewImage,
  collectionCode,
  line,
  collection,
  calculatedColors,
  sortColors,
  forceVisible,
  forceColorInvisibility,
  forceVisibleFromModal,
  totalQuantityC,
  totalPriceC,
  expandAll,
  totalQuantity,
  totalPrice,
  callbackRemoved,
  sessionAddedColors,
}) => {
  const lang = localStorage.getItem("B2BLanguage") === "ITA" ? "it" : "en";

  const mobileScrollAnchor = useRef();

  const dispatch = useDispatch();
  const { order, configuration } = useSelector((state) => state.yodaOrders);
  const [removeProduct, setRemoveProduct] = useState(false);
  const { customer } = useSelector((state) => state.yodaCustomer);
  const { catalogueItemDetailsSwap } = useSelector(
    (state) => state.yodaCatalogue,
  );

  const { offsetTop } = useSelector((state) => state.system);

  const [deleteMessage, setDeleteMessage] = useState();
  const [colorCode, setColorCode] = useState();
  const [mModelCode, setMModelCode] = useState();
  const [showDetails, setShowDetails] = useState(false);
  const [showAllColors, setShowAllColors] = useState(false);

  const handleVisibleFromModal = (code) => {
    forceVisibleFromModal(code);
    setTimeout(() => {
      mobileScrollAnchor?.current?.scrollIntoView?.({
        behavior: "smooth",
      });
    });
  };

  const handleColorInvisibility = (code) => {
    forceColorInvisibility(code);
    setTimeout(() => {
      mobileScrollAnchor?.current?.scrollIntoView?.({
        behavior: "smooth",
      });
    });
  };
  useEffect(() => {
    expandAll ? setShowDetails(true) : setShowDetails(false);
  }, [expandAll]);

  return (
    <>
      <ToastMessage
        message={deleteMessage}
        needConfirm={true}
        confirmFunction={(ev) => {
          dispatch(
            yodaOrdersActions.removeProduct(
              order.id,
              config.ORDER_TYPE_REORDER,
              id,
              mModelCode,
              colorCode,
            ),
          );
          if (removeProduct) {
            callbackRemoved();
          }
          setDeleteMessage(null);
          setRemoveProduct(false);
          setColorCode(null);
          setMModelCode(null);
          if (colorCode) {
            handleColorInvisibility(colorCode);
          }
          ev.preventDefault();
          ev.stopPropagation();
          ev.nativeEvent.stopImmediatePropagation();
        }}
        cancelFunction={(ev) => {
          setDeleteMessage(null);
          setRemoveProduct(false);
          setColorCode(null);
          setMModelCode(null);
          ev.preventDefault();
          ev.stopPropagation();
          ev.nativeEvent.stopImmediatePropagation();
        }}
        style={{ width: 600 }}
      />
      <Flex flexDirection="column" sx={{ position: "relative" }}>
        <Box
          sx={{ position: "absolute", top: -offsetTop, pointerEvents: "none" }}
          ref={mobileScrollAnchor}
        ></Box>
        {/* IMAGE & DETAILS */}
        <Flex justifyContent="left" width="100%">
          <ProductImage
            img={previewImage}
            scale={"1.4"}
            width={"120px"}
            height={"190px"}
          ></ProductImage>
          <Flex width="calc(100% - 120px)" p="10px" flexDirection="column">
            <Flex
              width="100%"
              justifyContent="right"
              onClick={() => setShowDetails(!showDetails)}
              style={{ gap: "12px" }}
            >
              {showDetails ? (
                <BsChevronUp
                  size="24px"
                  onClick={() => setShowDetails(!showDetails)}
                />
              ) : (
                <BsChevronDown
                  size="24px"
                  onClick={() => setShowDetails(!showDetails)}
                />
              )}
              <Flex
                alignItems="center"
                bg="black"
                onClick={(evt) => {
                  setMModelCode(modelCode);
                  setDeleteMessage(
                    getLocalizedString("DELETEORDER_ITEM_MESSAGE") +
                      modelCode +
                      " ?",
                  );
                  setRemoveProduct(true);
                  evt.preventDefault();
                  evt.stopPropagation();
                  evt.nativeEvent.stopImmediatePropagation();
                }}
              >
                <IoMdClose color="white" size="20px" />
              </Flex>
            </Flex>
            <Flex flexDirection="column">
              <Box>
                <span style={{ marginRight: "5px" }}>
                  {getLocalizedString("Codice modello")}:
                </span>
                <span style={{ fontWeight: "bold" }}>{modelCode}</span>
              </Box>
              <Box>
                <span style={{ marginRight: "5px" }}>
                  {getLocalizedString("Codice collezione")}:
                </span>
                <span style={{ fontWeight: "bold" }}>{collectionCode}</span>
              </Box>
              <Box>
                <span style={{ marginRight: "5px" }}>
                  {getLocalizedString("Linea")}:
                </span>
                <span style={{ fontWeight: "bold" }}>
                  {configuration
                    ?.filter?.((f) => f.typeId == order?.orderTypeId)?.[0]
                    ?.configuration?.filter((f) => f.line == line)?.[0]
                    ?.lineDescription?.[lang] || ""}
                </span>
              </Box>
              <Box>
                <span style={{ marginRight: "5px" }}>
                  {getLocalizedString("Collezione")}:
                </span>
                <span style={{ fontWeight: "bold" }}>{collection}</span>
              </Box>
              <Flex
                alignItems="center"
                style={{ gap: "4px" }}
                mt="10px"
                onClick={() => setShowAllColors(!showAllColors)}
              >
                <CgColorPicker />
                <span style={{ fontSize: "14px" }}>
                  {getLocalizedString("COLORS AVAILABILITY")}
                </span>
              </Flex>
              {showAllColors && (
                <ColorsSideBar
                  colors={calculatedColors}
                  id={id}
                  onClose={() => setShowAllColors(!showAllColors)}
                  forceVisible={handleVisibleFromModal}
                  offsetTop={50}
                />
              )}
            </Flex>
          </Flex>
        </Flex>
        {/* END - IMAGE & DETAILS */}
        {/* COLORS & AVAILABILITY */}
        {showDetails && (
          <Flex m="10px" flexDirection="column">
            <Flex
              width="100%"
              justifyContent="end"
              onClick={() => setShowDetails(!showDetails)}
            ></Flex>
            {sortColors(calculatedColors).map((color, i) => (
              <Flex
                key={i}
                mb="4px"
                style={{
                  display: forceVisible[color.code] ? "" : "none",
                }}
              >
                <OrderInfo
                  id={id}
                  color={color}
                  customer={customer}
                  totalPrice={totalPriceC[color.code]}
                  totalQuantity={totalQuantityC[color.code]}
                  catalogueItems={catalogueItemDetailsSwap}
                  modelCode={modelCode}
                  forceVisible={forceVisible}
                  type={config.ORDER_TYPE_SWAP}
                  forceColorInvisibility={(color) =>
                    handleColorInvisibility(color)
                  }
                  isLastAdded={
                    sessionAddedColors?.includes?.(color.code) && i === 0
                  }
                />
              </Flex>
            ))}
          </Flex>
        )}
        {/* END - COLORS & AVAILABILITY */}
        <Flex
          alignItems="center"
          flex={1}
          sx={{
            gap: "2px",
            mx: "10px",
            fontWeight: "bold",
            borderTop: "1px solid #c2c2c2",
          }}
        >
          <Box width="33.3%" textAlign={"center"}>
            {getLocalizedString("TOTALE")}
          </Box>
          <Box width="66.6%">
            <OrderInfoRow
              quantity={totalQuantity || 0}
              price={totalPrice}
              isTotal
              bg={"#fff"}
            />
          </Box>
        </Flex>
      </Flex>
    </>
  );
};

export default MobileOrderDetailSwap;
